import { DistinctNamesValues, distinctNames } from '../../GeoTargeter';

export const plainItems = [
  distinctNames.countries,
  distinctNames.empty,
  distinctNames.country,
] as DistinctNamesValues[];
